<template>
  <div>
    <div class="input-group mb-4">
      <button class="btn btn-outline-dark" id="github-btn" v-on:click="link" v-bind:disabled="status !== 'off' && status !== 'error'">
        <i class="fab fa-github" v-show="status === 'off'" />
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="status === 'pending'"></span>
        <i class="fas fa-times" v-show="status === 'error'" />
        <i class="fas fa-check" v-show="status === 'on'" />
        <span class="ml-1" v-show="status !== 'error'">Dual license a GitHub project</span>
        <span class="ml-1" v-show="status === 'error'">Error</span>
      </button>
      <select class="form-control ml-1" v-show="repos !== null" v-model="repo" :disabled="repoConfirmed">
        <option v-for="repo in repos" v-bind:key="repo">{{ repo }}</option>
      </select>
      <button class="btn disabled" v-show="status === 'on' && repos === null">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </button>
      <button class="btn btn-outline-primary ml-1" v-show="repos !== null && !repoConfirmed" @click="repoConfirmed = true">
        <i class="fas fa-arrow-right" />
      </button>
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase/app"
import "firebase/auth"

firebase.initializeApp({
  apiKey: "AIzaSyDoa_HeZjYemhDcQanewvya2FDYjmpzgVI",
  authDomain: "license.land",
  databaseURL: "https://licenseland.firebaseio.com",
  projectId: "licenseland",
  storageBucket: "licenseland.appspot.com",
  messagingSenderId: "633090897343",
  appId: "1:633090897343:web:f52efc016c10d484"
})

const scrollDown = function() {
  window.setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 50)
}

export default {
  name: 'GitHubButton',
  data: () => ({
    error: null,
    prStatus: 'off',
    prUrl: null,
    repo: null,
    repoConfirmed: false,
    repos: null,
    status: 'off',
    username: null
  }),
  methods: {
    link: async function() {
      this.status = 'pending'

      const provider = new firebase.auth.GithubAuthProvider()
      provider.addScope('repo') // required
      await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      firebase.auth().signInWithPopup(provider).then(result => {
        this.status = 'on'
        localStorage.setItem('github:accessToken', result.credential.accessToken)
        firebase.auth().currentUser.getIdToken(true).then(token => document.cookie = `__session=${token}`)

        fetch('https://api.github.com/user', {
          headers: {
            'Authorization': `token ${localStorage.getItem('github:accessToken')}`,
            'User-Agent': 'Licenseland'
          }
        }).then(response => response.json()).then(response => {
          ['id', 'login', 'avatar_url', 'node_id', 'name', 'company', 'email', 'location', 'bio'].forEach(key => {
            localStorage.setItem(`github:${key}`, response[key])
          })
        })

        fetch('https://api.github.com/user/repos?sort=pushed', {
          headers: {
            'Authorization': `token ${localStorage.getItem('github:accessToken')}`,
            'User-Agent': 'Licenseland'
          }
        }).then(response => response.json()).then(response => {
          this.repos = response.map(repo => repo.full_name)
          this.repo = this.repos[0]
        })

      }).catch(error => {
        this.status = 'error'

        // Handle Errors here.
        // var errorCode = error.code
        var errorMessage = error.message
        // The email of the user's account used.
        // var email = error.email
        // The firebase.auth.AuthCredential type that was used.
        // var credential = error.credential
        throw errorMessage
      })
    },
    pull: function() {
      this.prStatus = 'pending'
      this.error = null
      // Start out the normal way with a plain object.
      var repo = {}

      // Mixin the main library using github to provide the following:
      // - repo.loadAs(type, hash) => value
      // - repo.saveAs(type, value) => hash
      // - repo.listRefs(filter='') => [ refs ]
      // - repo.readRef(ref) => hash
      // - repo.updateRef(ref, hash) => hash
      // - repo.deleteRef(ref) => null
      // - repo.createTree(entries) => hash
      // - repo.hasHash(hash) => has
      require('js-github/mixins/github-db')(repo, this.repo, localStorage.getItem('github:accessToken'));
      require('js-git/mixins/create-tree')(repo)

      // Cache github objects locally in indexeddb
      //var db = require('js-git/mixins/indexed-db')
      //require('js-git/mixins/add-cache')(repo, db)

      // Cache everything except blobs over 100 bytes in memory.
      // This makes path-to-hash lookup a sync operation in most cases.
      require('js-git/mixins/mem-cache')(repo)

      // Combine concurrent read requests for the same hash
      require('js-git/mixins/read-combiner')(repo)

      // Add in value formatting niceties.  Also adds text and array types.
      require('js-git/mixins/formats')(repo)

      // Browser only: we need to initialize the indexeddb
      //db.init(function(err) {
        //if (err) throw err;
      //})

      const self = this

      var run = require('gen-run')
      run(function* () {
        var headHash = yield repo.readRef("refs/heads/master")
        var commit = yield repo.loadAs("commit", headHash)
        var tree = yield repo.loadAs("tree", commit.tree)
        var entry = tree["README.md"]
        var readme = yield repo.loadAs("text", entry.hash)

        // Build the updates array
        var updates = [{
          path: "README.md", // Update the existing entry
          mode: entry.mode,  // Preserve the mode (it might have been executible)
          content: `${readme}` // Write the new content
        },
        {
          path: "LICENSE",
          mode: entry.mode,  // Preserve the mode (it might have been executible)
          content: `This software is DUAL-LICENSED under the`
        }]
        // Based on the existing tree, we only want to update, not replace.
        updates.base = commit.tree

        // Create the new file and the updated tree.
        var treeHash = yield repo.createTree(updates);
        var commitHash = yield repo.saveAs("commit", {
          tree: treeHash,
          author: {
            name: "Licenseland",
            email: "hi@license.land"
          },
          parent: headHash,
          message: "Add dual-licensing"
        })

        try {
          if (self.repo === 'glacials/splits-io') {
            const error = 'That is Splits.io'
            throw error
          }
          yield repo.updateRef("refs/heads/dual-license", commitHash)
        } catch(error) {
          self.error = error
          self.prStatus = 'error'
          throw error
        }
        self.prStatus = 'on'
        fetch(`https://api.github.com/repos/${self.repo}/pulls`, {
          body: JSON.stringify({
            base: 'master',
            body: '*Generated automatically by [license.land][1] with permission.*\n\n[1]: https://license.land',
            head: 'dual-license',
            maintainer_can_modify: true,
            title: 'Add dual-licensing'
          }),
          headers: {Authorization: `token ${localStorage.getItem('github:accessToken')}`}, // user token
          // headers: {Authorization: 'token a6830cea4f912b2950f64ed91866abdc10896c22'}, // self token
          method: 'POST'
        }).then(response => response.json()).then(response => {
          self.prUrl = response.html_url
          self.$emit('complete')
        })
      })
    }
  },
  props: ['value'],
  watch: {
    repoConfirmed: function() {
      scrollDown()
      this.$emit('input', this.repo)
      fetch(`${process.env.VUE_APP_FIREBASE_FUNCTIONS_BASE_URL}/github?repo=${this.repo}&accessToken=${localStorage.getItem('github:accessToken')}`, {
        credentials: 'include',
        method: 'POST',
      })
    },
  },
}
</script>
